//ASSETS
import { IMAGES } from "../assets";

//COPONENTS
import { LATextInput, LAButton, LAView, LAText } from "../components";

//PACKAGES
import { useNavigate } from "react-router-dom";

//CONSTANT
import { STRINGS } from "../constant";
import {
  SIGN_IN_GOOGLE,
  SIGN_UP_APPLE,
  SIGN_UP_FIREBASE,
} from "../api/firebase_auth";
import { SHOW_TOAST, detectOS } from "../constant/utils";
import { useContext, useEffect, useState } from "react";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import { MixpanelContext } from "../context/MixpanelProvider";
import { ThemeContext } from "../context/ThemeProvider";
import { emailRegex } from "../constant/utils";
import { getAppLogo } from "../api/theme_settings";
import useFeatureList from "../hooks/useFeatureList";
import { getThemeBlackWhiteColor } from "../utils/themeUtils";

function Signup() {
  const navigation = useNavigate();
  const [signUpState, setSignUpState] = useState({ isLoading: false });
  const [os, setOs] = useState("");
  const { trackSignup } = useContext(MixpanelContext);
  const [showPassword, setShowPassword] = useState(false);
  const featureList = useFeatureList();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const signInWithGoogleHandler = async () => {
    setSignUpState((prev) => ({ ...prev, isLoading: true }));
    const result = await SIGN_IN_GOOGLE();

    setSignUpState((prev) => ({ ...prev, isLoading: false }));
    if (result.status) {
      moveToPrepare(result.data, "google");
      navigation("/home");
    } else if (result.error) {
      SHOW_TOAST(result.error, "error", 5000);
    }
  };

  const signInWithAppleHandler = async () => {
    setSignUpState((prev) => ({ ...prev, isLoading: true }));
    const result = await SIGN_UP_APPLE();

    setSignUpState((prev) => ({ ...prev, isLoading: false }));
    if (result.status) {
      moveToPrepare(result.data, "apple");
      navigation("/home");
    } else if (result.error) {
      SHOW_TOAST(result.error, "error", 5000);
    }
  };

  const handleSubmit = async (value, { resetForm }) => {
    setSignUpState((prev) => ({ ...prev, isLoading: true }));
    const result = await SIGN_UP_FIREBASE(value?.email, value?.password);
    setSignUpState((prev) => ({ ...prev, isLoading: false }));

    if (result.status) {
      const name = value?.firstName + " " + value?.lastName;
      trackSignup("email", name);
      moveToPrepare(value?.firstName, value?.lastName);
    } else {
      SHOW_TOAST(result.error, "error");
    }

    resetForm();

  };

  async function moveToPrepare(firstName, lastName) {
    navigation("/prepare", {
      state: {
        params: {
          firstName: firstName,
          lastName: lastName,
          isFromOnboarding: true,
          isFromLoginSignup: true,
          type: "email",
        },
      },
    });
  }

  //const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const validationSchema = Yup.object().shape({
    first_name: Yup.string()
      .min(2, "Enter atleast 2 characters")
      .required("Please enter the first name")
      .matches(/^(\S+$)/g, "This field cannot contain only blankspaces")
      .matches(/^[a-zA-Z]+$/, "Only alphabetic characters allowed"),
    last_name: Yup.string()
      .min(2, "Enter atleast 2 characters")
      .required("Please enter the last name")
      .matches(/^(\S+$)/g, "This field cannot contain only blankspaces")
      .matches(/^[a-zA-Z]+$/, "Only alphabetic characters allowed"),
    email: Yup.string().required("Please enter the field"),
    email: Yup.string()
      .matches(emailRegex, "Invalid email address")
      .required("Please enter the email"),
    password: Yup.string()
      .required("Please enter the password")
      .min(6, "Password must contain at least 6 characters")
      .matches(/^\S*$/, "Password should not contain any whitespace")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/\d/, "Password must contain at least one digit")
      .matches(/[@$!%*?&]/, "Password must contain at least one special character"),


  });

  useEffect(() => {
    const detectedOs = detectOS();
    setOs(detectedOs);
  }, []);


  const [logo, setLogo] = useState(null);
  const { theme, setCurrentTheme , currentTheme} = useContext(ThemeContext);

  useEffect(() => {
    getAppLogo(currentTheme).then(setLogo);
  }, []);

  useEffect(() => {
    if (theme) {
      document.documentElement.style.setProperty("--lz-blue", theme.COLOR_LZ_BLUE);
      document.documentElement.style.setProperty("--lz-blue-5", theme.COLOR_LZ_BLUE_5);
      document.documentElement.style.setProperty("--lz-blue-4", theme.COLOR_LZ_BLUE_4);
      document.documentElement.style.setProperty("--lz-blue-3", theme.COLOR_LZ_BLUE_3);
      document.documentElement.style.setProperty("--lz-blue-2", theme.COLOR_LZ_BLUE_2);
      document.documentElement.style.setProperty("--lz-blue-1", theme.COLOR_LZ_BLUE_1);
      document.documentElement.style.setProperty("--lz-blue-6", theme.COLOR_LZ_BLUE_6);
      document.documentElement.style.setProperty("--lz-blue-7", theme.THEME_DARK_MODE);
      document.documentElement.style.setProperty("--lz-blue-8", theme.COLOR_LZ_BLUE_8);
      document.documentElement.style.setProperty("--lz-blue-9", theme.THEME_DARK_MODE);
      document.documentElement.style.setProperty("--lz-blue-10", theme.COLOR_LZ_BLUE_10);

      document.documentElement.style.setProperty("--lz-orange", theme.COLOR_LZ_ORANGE);
      document.documentElement.style.setProperty("--lz-orange-5", theme.COLOR_LZ_ORANGE_5);
      document.documentElement.style.setProperty("--lz-orange-4", theme.COLOR_LZ_ORANGE_4);
      document.documentElement.style.setProperty("--lz-orange-3", theme.COLOR_LZ_ORANGE_3);
      document.documentElement.style.setProperty("--lz-orange-2", theme.COLOR_LZ_ORANGE_2);
      document.documentElement.style.setProperty("--lz-orange-1", theme.COLOR_LZ_ORANGE_1);
      document.documentElement.style.setProperty("--lz-orange-6", theme.COLOR_LZ_ORANGE_6);
      document.documentElement.style.setProperty("--lz-orange-7", theme.COLOR_LZ_ORANGE_7);
      document.documentElement.style.setProperty("--lz-orange-8", theme.COLOR_LZ_ORANGE_8);
      document.documentElement.style.setProperty("--lz-orange-9", theme.COLOR_LZ_ORANGE_9);
      document.documentElement.style.setProperty("--lz-orange-10", theme.COLOR_LZ_ORANGE_10);
    }
  }, [theme]);

  return (
    <>
      <div className="min-h-screen flex items-center justify-center" style={{ background: getThemeBlackWhiteColor(theme, currentTheme) }}>
        <div className="w-full max-w-md p-8 space-y-8 bg-white dark:bg-gray-900 rounded-lg shadow-lg">
          <div className="text-center mb-8">
            <img src={logo} alt="LearnZapp" className="w-1/2 mx-auto" />
            <h1 className="text-2xl mt-4 text-black dark:text-white">Create Account</h1>
            <p className="text-gray-600 text-black dark:text-gray-400">Sign up to start your learning journey</p>
          </div>
          <Formik
            initialValues={{
              first_name: "",
              last_name: "",
              email: "",
              password: "",
            }}
            enableReinitialize
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            {({
              values,
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              resetForm,
              setFieldValue,
            }) => {
              return (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <div className="relative w-full">
                      <img src={IMAGES.ic_profile} alt="Profile Icon" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5" />
                      <input
                        type="text"
                        name="first_name"
                        id="first_name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.first_name}
                        placeholder="First Name"
                        className="w-full pl-10 pr-4 py-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600"
                      />
                    </div>
                    <ErrorMessage
                      name="first_name"
                      component="div"
                      className="text-rose-500 text-xs"
                    />
                  </div>
                  <div>
                    <div className="relative w-full">
                      <img src={IMAGES.ic_profile} alt="Profile Icon" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5" />
                      <input
                        type="text"
                        name="last_name"
                        id="last_name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.last_name}
                        placeholder="Last Name"
                        className="w-full pl-10 pr-4 py-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600"
                      />
                    </div>
                    <ErrorMessage
                      name="last_name"
                      component="div"
                      className="text-rose-500 text-xs"
                    />
                  </div>
                  <div>
                    <div className="relative w-full">
                      <img src={IMAGES.ic_email} alt="Email Icon" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5" />
                      <input
                        type="email"
                        name="email"
                        id="email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.email}
                        placeholder="Email address"
                        className="w-full pl-10 pr-4 py-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600"
                      />
                    </div>
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-xs text-rose-500 mt-1"
                    />
                  </div>
                  <div>
                    <div className="relative w-full">
                      <img src={IMAGES.ic_lock} alt="Password Icon" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5" />
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        id="password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.password}
                        placeholder="Password"
                        className="w-full pl-10 pr-10 py-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600"
                      />
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600 dark:text-gray-300 focus:outline-none"
                      >
                        <img src={showPassword ? IMAGES.ic_hide : IMAGES.ic_view} alt="Toggle Password Visibility" className="w-5 h-5" />

                      </button>
                    </div>
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-xs text-rose-500 mt-1"
                    />
                  </div>
                  <div className="space-y-4 mt-6">

                    <button
                      type="submit"
                      className="w-full text-white py-4 rounded-lg bg-gray-600 hover:bg-gray-800 transition dark:bg-gray-200 dark:hover:bg-gray-600 text-gray-900 dark:text-gray-900"
                    >
                      {STRINGS.singup}
                    </button>

                    {featureList?.signin.social_sign_in &&
                      <button
                        type="button"
                        onClick={signInWithGoogleHandler}
                        className="w-full flex items-center justify-center bg-white border border-gray-300 text-gray-600 py-4 rounded-lg hover:bg-gray-100 transition dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:hover:bg-gray-600"
                      >
                        <img src={IMAGES.ic_google} alt="Google Icon" className="w-6 h-6 mr-2" />
                        {STRINGS.google}
                      </button>
                    }
                    {featureList?.signin.social_sign_in &&
                      <button
                        type="button"
                        onClick={signInWithAppleHandler}
                        className="w-full flex items-center justify-center bg-white border border-gray-300 text-gray-600 py-4 rounded-lg hover:bg-gray-100 transition dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:hover:bg-gray-600"
                      >
                        <img src={IMAGES.ic_apple} alt="Apple Icon" className="w-6 h-6 mr-2" />
                        {STRINGS.apple}
                      </button>
                    }
                  </div>
                </form>
              );
            }}
          </Formik>
          <p
            className="justify-center pt-10 text-center text-gray-600 dark:text-gray-400"
          >
            {STRINGS.already_have_account}  <span className="text-blue-500 cursor-pointer hover:underline dark:text-blue-400" onClick={() => navigation("/login")}> Login </span>
          </p>

        </div>
      </div>
    </>
  );
}

export default Signup;
